import gql from 'graphql-tag'
import { main } from './fragments'

export default gql`
query getProductGroup($id: ID!) {
	cashAssist {
		getProductGroup(id: $id) {
			...productGroupMain
		}
	}
}
${main}`
